"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListItemIconOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            color: palette.text.secondary,
        },
    });
};
//# sourceMappingURL=MuiListItemIcon.js.map